// test2294
(2294 && 0);
